export default "__VITE_ASSET__CHgM0uv6__"